import React from "react";
import styles from "./SpaceDot.module.css"; // 스타일 파일 경로에 맞게 조정해주세요

interface ColorIconProps {
  color: string;
  className?: string;
  style?: React.CSSProperties;
}

const SpaceDot = ({ color, className, style }: ColorIconProps) => {
  return (
    <div
      className={`${styles["spaceDot"]} ${className || ""}`}
      style={{
        backgroundColor: color,
        boxShadow: `0 0 0 2px ${color} inset`,
        ...style,
      }}
    />
  );
};

export default SpaceDot;
